// ============================================================================
// Liens externes vers le site principal de l'organisme (cecodev.fr)
// ============================================================================
// Les documents généraux (règlement intérieur, CGV, CGU, mentions légales)
// sont hébergés sur le site vitrine de l'organisme afin d'éviter la
// duplication et de garantir une version unique, facile à mettre à jour.
// Le footer et le formulaire d'inscription pointent vers ces URLs avec
// `target="_blank"` (changement de domaine).
//
// URLs réelles confirmées le 2026-04-23. La base peut être surchargée en
// production via la variable d'environnement Vite `VITE_CECODEV_SITE_URL`.
// ============================================================================

const SITE_BASE = (import.meta.env.VITE_CECODEV_SITE_URL || "https://cecodev.fr").replace(/\/$/, "");

export const EXTERNAL_LINKS = {
  siteAccueil: `${SITE_BASE}/`,
  reglementInterieur: `${SITE_BASE}/reglement-interieur/`,
  cgv: `${SITE_BASE}/conditions-generales-de-vente-pour-les-formations/`,
  cgu: `${SITE_BASE}/cgu/`,
  mentionsLegales: `${SITE_BASE}/mentions-legales/`,
} as const;

